export const APPROVED = 'APPROVED';
export const AWAITING_VERIFICATION = 'AWAITING_VERIFICATION';
export const AWAITING_MODIFICATION = 'AWAITING_MODIFICATION';
export const REJECTED = 'REJECTED';

export const DEFAULT_COUNTRY = {
  alpha_2: 'RU',
  cis_member: false,
  id: 1,
  merchant_identification_citizenship: true,
  name: 'common.russia',
};

export const DEFAULT_IDENTIFICATION = {
  birthDate: null,
  country: DEFAULT_COUNTRY,
  documentId: null,
  documentIssueDate: null,
  firstName: null,
  insuranceNumber: null,
  patronymic: null,
  placeOfBirth: null,
  rejectionReason: null,
  secondName: null,
  status: null,
  type: 'INTERNAL',
};

export const PASSPORTS = [
  {
    alpha_2: 'AZ',
    label: 'passport.id',
    placeholder: 'С00000000',
    validation: /^[A-Z]{1}\d{8}$/,
  },
  {
    alpha_2: 'AM',
    label: 'passport.series.and.id',
    placeholder: 'АА0408004',
    validation: /^A[A-Z]0\d{6}$/,
  },
  {
    alpha_2: 'BY',
    label: 'identification.number',
    placeholder: '7677266А001РВ9',
    validation: /^\d{7}([А-Я]|[A-Z])\d{3}([А-Я]|[A-Z]){2}\d$/,
  },
  {
    alpha_2: 'GE',
    label: 'passport.id',
    placeholder: '00IA00602',
    validation: /(([A-Z])|([0-9])){2,}/,
  },
  {
    alpha_2: 'KZ',
    label: 'identification.document.number',
    placeholder: '571028302728',
    validation: /^\d{12}$/,
  },
  {
    alpha_2: 'MD',
    label: 'passport.id',
    placeholder: 'AA0000000',
    validation: /^\w{1,2}\d{7,8}$/,
  },
  {
    alpha_2: 'KG',
    label: 'identification.passport',
    placeholder: 'АА0000000',
    validation: /^[A-Z]{2}\d{7}$/,
  },
  {
    alpha_2: 'RU',
    label: 'passport.series.and.id',
    placeholder: '2202481322',
    validation: /^\d{10}$/,
  },
  {
    alpha_2: 'TJ',
    label: 'passport.id',
    placeholder: '420275178',
    validation: /^\d{9}$/,
  },
  {
    alpha_2: 'UZ',
    label: 'passport.id',
    placeholder: 'AA0000000',
    validation: /(^[A-Z]{2}\d{7}$)|(^\d{15})$/,
  },
  {
    alpha_2: 'UA',
    label: 'passport.series.and.id',
    placeholder: 'АА000000',
    validation: /^\d{9}$|^(([А-Я]{2})|([A-Z]{2}))\d{6}$/,
  },
];
